<template>
    <div class="costcenter">
        <PageTitle
            icon="fa fa-clone"
            main="Registro"
            sub="Centro de Resultado"
        />
        <b-form
            v-show="mode === 'save' || mode === 'remove' || mode === 'read'"
        >
            <input id="costcenter-id" type="hidden" v-model="costcenter.id" />
            <b-row>
                <b-col md="6" sm="12">
                    <b-form-group
                        label="Nome:"
                        label-for="costcenter-name_cost_center"
                    >
                        <b-form-input
                            id="costcenter-name_cost_center"
                            type="text"
                            ref="searchFocus"
                            v-model="costcenter.name_cost_center"
                            required
                            size="sm"
                            :readonly="
                                mode === 'remove' ||
                                    mode === 'read' ||
                                    mode === 'insert'
                            "
                            placeholder="Nome..."
                        />
                    </b-form-group>
                </b-col>
                <b-col md="3" sm="12">
                    <b-form-group
                        label="Código:"
                        label-for="costcenter-internal_code_cost_center"
                    >
                        <b-form-input
                            id="costcenter-internal_code_cost_center"
                            type="text"
                            v-model="costcenter.internal_code_cost_center"
                            required
                            size="sm"
                            :readonly="
                                mode === 'remove' ||
                                    mode === 'read' ||
                                    mode === 'insert'
                            "
                            placeholder="Código..."
                        />
                    </b-form-group>
                </b-col>
                <b-col md="3" sm="12">
                    <div class="form-group">
                        <div class="form-check">
                            <input
                                class="form-check-input"
                                v-model="costcenter.synthetic"
                                true-value="1"
                                false-value="0"
                                type="checkbox"
                                id="costcenter-synthetic"
                                :disabled="
                                    mode === 'remove' ||
                                        mode === 'read' ||
                                        mode === 'insert'
                                "
                            />
                            <label
                                class="form-check-label"
                                for="costcenter-synthetic"
                            >
                                Sintético?
                            </label>
                        </div>
                    </div>
                </b-col>
            </b-row>
            <b-row>
                <b-col md="3" sm="12">
                    <div class="form-group">
                        <div class="form-check">
                            <input
                                class="form-check-input"
                                v-model="costcenter.cost_center_default_sale"
                                true-value="1"
                                false-value="0"
                                type="checkbox"
                                id="costcenter-cost_center_default_sale"
                                :disabled="
                                    mode === 'remove' ||
                                        mode === 'read' ||
                                        mode === 'insert'
                                "
                            />
                            <label
                                class="form-check-label"
                                for="costcenter-cost_center_default_sale"
                            >
                                Padrão para Venda?
                            </label>
                        </div>
                    </div>
                </b-col>
                <b-col md="3" sm="12">
                    <div class="form-group">
                        <div class="form-check">
                            <input
                                class="form-check-input"
                                v-model="costcenter.standard_financial"
                                true-value="1"
                                false-value="0"
                                type="checkbox"
                                id="costcenter-standard_financial"
                                :disabled="
                                    mode === 'remove' ||
                                        mode === 'read' ||
                                        mode === 'insert'
                                "
                            />
                            <label
                                class="form-check-label"
                                for="costcenter-standard_financial"
                            >
                                Padrão para Financeiro?
                            </label>
                        </div>
                    </div>
                </b-col>
                <b-col md="3" sm="12">
                    <div class="form-group">
                        <div class="form-check">
                            <input
                                class="form-check-input"
                                v-model="costcenter.standard_stock"
                                true-value="1"
                                false-value="0"
                                type="checkbox"
                                id="costcenter-standard_stock"
                                :disabled="
                                    mode === 'remove' ||
                                        mode === 'read' ||
                                        mode === 'insert'
                                "
                            />
                            <label
                                class="form-check-label"
                                for="costcenter-standard_stock"
                            >
                                Padrão para Estoque?
                            </label>
                        </div>
                    </div>
                </b-col>
                <b-col md="3" sm="12">
                    <div class="form-group">
                        <div class="form-check">
                            <input
                                class="form-check-input"
                                v-model="costcenter.blocked"
                                true-value="1"
                                false-value="0"
                                type="checkbox"
                                id="costcenter-blocked"
                                :disabled="
                                    mode === 'remove' ||
                                        mode === 'read' ||
                                        mode === 'insert'
                                "
                            />
                            <label
                                class="form-check-label"
                                for="costcenter-blocked"
                            >
                                Bloqueado?
                            </label>
                        </div>
                    </div>
                </b-col>
            </b-row>
            <b-row>
                <b-col md="6" sm="12">
                    <b-form-group
                        label="Tipo de Grupo Custo/Receita:"
                        label-for="costcenter-type_group_cost_recipe_id"
                    >
                        <b-form-select
                            id="costcenter-type_group_cost_recipe_id"
                            :disabled="
                                mode === 'remove' ||
                                    mode === 'read' ||
                                    mode === 'insert'
                            "
                            size="sm"
                            :options="typegroupcostrecipes"
                            v-model="costcenter.type_group_cost_recipe_id"
                        />
                    </b-form-group>
                </b-col>
                <b-col md="6" sm="12">
                    <b-form-group
                        label="Empresa:"
                        label-for="costcenter-cost_center_company_id"
                    >
                        <b-form-select
                            id="costcenter-cost_center_company_id"
                            :disabled="
                                mode === 'remove' ||
                                    mode === 'read' ||
                                    mode === 'insert'
                            "
                            size="sm"
                            :options="companys"
                            v-model="costcenter.cost_center_company_id"
                        />
                    </b-form-group>
                </b-col>
            </b-row>
        </b-form>
        <hr v-show="mode === 'save'" />
        <b-row>
            <b-col xs="12">
                <b-button
                    size="sm"
                    variant="light"
                    class="mt-2  mb-2 fa fa-plus"
                    v-show="mode !== 'save' && mode !== 'remove'"
                    @click="alterModo"
                >
                </b-button>
                <b-button
                    size="sm"
                    variant="light"
                    class="mt-2 mb-2 ml-2 fa fa-save"
                    v-if="mode === 'save'"
                    @click="save"
                >
                </b-button>
                <b-button
                    size="sm"
                    variant="light"
                    class="mt-2 mb-2 ml-2 fa fa-trash"
                    v-if="mode === 'remove'"
                    @click="remove"
                >
                </b-button>
                <b-button
                    size="sm"
                    btn-sm
                    variant="light"
                    class="mt-2 mb-2 ml-2 fa fa-ban"
                    v-if="
                        mode === 'remove' || mode === 'save' || mode === 'read'
                    "
                    @click="reset"
                >
                </b-button>
                <b-button
                    size="sm"
                    class="mt-2 mb-2 ml-2 fa"
                    :class="icon"
                    @click="
                        ;[
                            loadCostCenters(),
                            toggleBusy(),
                            (showTable = !showTable)
                        ]
                    "
                    variant="light"
                >
                </b-button>
            </b-col>
        </b-row>
        <br />
        <div class="col-sm-4">
            <div class="form-group">
                <input
                    type="text"
                    size="sm"
                    icon="search"
                    v-model="search"
                    v-show="mode !== 'save' && mode !== 'remove'"
                    ref="searchFocus"
                    placeholder="Informe a descrição"
                    class="form-control"
                />
            </div>
        </div>
        <transition name="slide" type="animation" appear>
            <b-table
                :busy="isBusy"
                class="table-responsive"
                v-show="showTable"
                hover
                key="slide"
                head-variant="light"
                :per-page="perPage"
                :current-page="currentPage"
                :items="filteredList"
                :fields="fields"
            >
                <template v-slot:table-busy>
                    <div class="text-center text-info my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong>Carregando...</strong>
                    </div>
                </template>
                <template v-slot:cell(actions)="data">
                    <b-button
                        title="Editar"
                        size="sm"
                        variant="light"
                        @click="loadCostCenter(data.item, 'read')"
                        class="mr-2 mt-2"
                    >
                        <i class="fa fa-drivers-license-o"></i>
                    </b-button>
                    <b-button
                        title="Editar"
                        size="sm"
                        variant="light"
                        @click="loadCostCenter(data.item)"
                        class="mr-2 mt-2"
                    >
                        <i class="fa fa-pencil"></i>
                    </b-button>
                    <b-button
                        pill
                        title="Excluir"
                        size="sm"
                        variant="light"
                        @click="loadCostCenter(data.item, 'remove')"
                        class="mr-2 mt-2"
                    >
                        <i class="fa fa-trash"></i>
                    </b-button>
                    <!--b-button pill  title = "Adicionar próximo Grupo de Item dentro do grupo" size="sm" variant="outline-success" @click="actionNewcostcenter(data.item)" class="mr-2 mt-2">
                            <i class="fa fa-plus"></i>
                    </b-button-->
                </template>
            </b-table>
        </transition>
        <transition name="slide" type="animation" appear>
            <b-pagination
                v-show="showTable"
                v-model="currentPage"
                :total-rows="rows"
                :per-page="perPage"
                size="sm"
                aria-controls="my-table"
            ></b-pagination>
        </transition>
    </div>
</template>

<script>
import { baseApiUrl, showError } from '@/global'
import axios from 'axios'
import PageTitle from '../template/PageTitle'

export default {
    name: 'CostCenter',
    components: { PageTitle },
    data: function() {
        return {
            mode: 'insert',
            search: '',
            costcenter: {},
            costcenters: [],
            typegroupcostrecipes: [],
            companys: [],
            showTable: false,
            isBusy: false,
            internal_code: null,
            currentPage: 1,
            perPage: 5,
            fields: [
                { key: 'id', label: 'Código', sortable: true },
                {
                    key: 'name_cost_center',
                    label: 'Descrição',
                    sortable: true,
                    variant: 'secondary'
                },
                {
                    key: 'internal_code_cost_center',
                    label: 'Código Interno',
                    sortable: false
                },
                {
                    key: 'synthetic',
                    label: 'Sintético',
                    sortable: false,
                    formatter: value => (value ? 'Sim' : 'Não')
                },
                {
                    key: 'name_type_group_cost_recipe',
                    label: 'Grupo de Custo/Receita',
                    sortable: false
                },
                { key: 'name_company', label: 'Empresa', sortable: false },
                {
                    key: 'cost_center_default_sale',
                    label: 'Venda',
                    sortable: false,
                    formatter: value => (value ? 'Sim' : 'Não')
                },
                {
                    key: 'standard_stock',
                    label: 'Estoque',
                    sortable: false,
                    formatter: value => (value ? 'Sim' : 'Não')
                },
                {
                    key: 'standard_financial',
                    label: 'Financeiro',
                    sortable: false,
                    formatter: value => (value ? 'Sim' : 'Não')
                },
                {
                    key: 'blocked',
                    label: 'Bloqueado',
                    sortable: false,
                    formatter: value => (value ? 'Sim' : 'Não')
                },
                { key: 'actions', label: 'Ações', variant: 'light' }
            ]
        }
    },
    computed: {
        filteredList() {
            return this.costcenters.filter(costcenter => {
                return costcenter.name_cost_center
                    .toLowerCase()
                    .includes(this.search.toLowerCase())
            })
        },
        icon() {
            return this.showTable ? 'fa-retweet' : 'fa-search'
        },
        rows() {
            return this.costcenters.length
        }
    },
    methods: {
        async loadCostCenters() {
            const url = `${baseApiUrl}/costcenters`
            await axios.get(url).then(res => {
                this.costcenters = res.data
                this.isBusy = false
            })
        },
        reset() {
            this.mode = 'insert'
            this.loadCostCenters()
        },
        toggleBusy() {
            this.isBusy = !this.isBusy
        },
        alterModo() {
            this.mode = 'save'
            this.$refs.searchFocus.focus()
            this.costcenter = {}
        },
        actionNewcostcenter(costcenter, mode = 'save') {
            this.mode = mode
            const sizearr = costcenter.internal_code_cost_center.length
            if (sizearr === 2) {
                let arr = costcenter.internal_code_cost_center.substring(0, 2)
                if (parseInt(arr).length === 2) {
                    this.costcenter.internal_code_cost_center =
                        parseInt(arr) + 1
                } else {
                    this.costcenter.internal_code_cost_center =
                        '0' + (parseInt(arr) + 1)
                }
            }
            if (sizearr === 5) {
                let arr = costcenter.internal_code_cost_center.substring(4, 5)
                if (parseInt(arr).length === 2) {
                    this.costcenter.internal_code_cost_center =
                        costcenter.internal_code_cost_center.substring(0, 2) +
                        (parseInt(arr) + 1)
                } else {
                    this.costcenter.internal_code_cost_center =
                        costcenter.internal_code_cost_center.substring(0, 4) +
                        (parseInt(arr) + 1)
                }
            }
            if (sizearr === 8) {
                let arr = costcenter.internal_code_cost_center.substring(7, 8)
                if (parseInt(arr).length === 2) {
                    this.costcenter.internal_code_cost_center =
                        costcenter.internal_code_cost_center.substring(0, 4) +
                        (parseInt(arr) + 1)
                } else {
                    this.costcenter.internal_code_cost_center =
                        costcenter.internal_code_cost_center.substring(0, 7) +
                        (parseInt(arr) + 1)
                }
            }
        },
        async save() {
            const method = this.costcenter.id ? 'put' : 'post'
            const id = this.costcenter.id ? `/${this.costcenter.id}` : ''
            await axios[method](
                `${baseApiUrl}/costcenters${id}`,
                this.costcenter
            )
                .then(() => {
                    this.$toasted.global.defaultSuccess()
                    this.reset()
                })
                .catch(showError)
        },
        async remove() {
            const id = this.costcenter.id
            await axios
                .delete(`${baseApiUrl}/costcenters/${id}`)
                .then(() => {
                    this.$toasted.global.defaultSuccess()
                    this.reset()
                })
                .catch(showError)
        },
        async loadTypeGroupCostRecipe() {
            const url = `${baseApiUrl}/typegroupcostrecipes`
            await axios.get(url).then(res => {
                this.typegroupcostrecipes = res.data.map(
                    typegroupcostrecipe => {
                        return {
                            value: typegroupcostrecipe.id,
                            text:
                                typegroupcostrecipe.name_type_group_cost_recipe
                        }
                    }
                )
            })
        },
        async loadCompanys() {
            const url = `${baseApiUrl}/companys`
            await axios.get(url).then(res => {
                this.companys = res.data.map(company => {
                    return { value: company.id, text: company.name_company }
                })
            })
        },
        loadCostCenter(costcenter, mode = 'save') {
            this.mode = mode
            this.costcenter = { ...costcenter }
        }
    },
    async mounted() {
        await this.loadTypeGroupCostRecipe(), await this.loadCompanys()
        this.$refs.searchFocus.focus()
    }
}
</script>

<style>
.costcenter {
    font-size: 0.7rem;
}

.costcenter input,
label,
form {
    font-size: 0.7rem;
}
.costcenter button {
    font-size: 0.7rem;
}

.costcenter select {
    font-size: 0.7rem;
}

.costcenter table {
    font-size: 0.7rem;
}

@keyframes slide-in {
    from {
        transform: translateY(40px);
    }
    to {
        transform: translateY(0);
    }
}

@keyframes slide-out {
    from {
        transform: translateY(0);
    }
    to {
        transform: translateY(40px);
    }
}

.slide-enter-active {
    animation: slide-in 1s ease;
    transition: opacity 1s;
}

.slide-leave-active {
    animation: slide-out 1s ease;
    transition: opacity 1s;
}

.slide-enter,
.slide-leave-to {
    opacity: 0;
}

.fade-enter,
.fade-leave-to {
    opacity: 0;
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity 1s;
}
</style>
